import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Admin from "layouts/Admin";
import { apiService } from "service/ApiService";
import ProtectedRoute from "components/ProtectedRoute.js/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Auth from "layouts/Auth.js";

// views without layouts

// import Landing from "views/Landing.js";
// import Profile from "views/Profile.js";
// import Index from "views/Index.js";

ReactDOM.render(
  <BrowserRouter>
    <ToastContainer />
    <Switch>
      <Route path="/auth" render={(props) => <Auth {...props} />} />
      <ProtectedRoute path="/admin" component={Admin} />
      <Redirect from="/" to={apiService.isTokenOk() ? "/admin/dashboard" : "auth/login"} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
